<template>
  <v-card>
    <v-card-title class="headline">
      <span>
        Export selected documents?
        <span class="grey--text subheading"></span>
      </span>
    </v-card-title>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="grey darken-1" flat @click="close()">Cancel</v-btn>
      <download-excel
        v-if="($route.name == 'rcti')"
        :fetch="fetchXeroCsvArray"
        type="csv"
        name="invoices.csv"
      >
        <v-btn
          :color="primaryNeutral"
          flat
          @click="exportDialog = false"
          :loading="loading"
        >Export Xero</v-btn>
      </download-excel>

      <download-excel :fetch="fetchApprovedCsvArray" type="csv" name="approvedBillLines.csv" v-else-if="$route.name == 'approvedBillLine'">
        <v-btn :color="primaryNeutral" flat @click="exportDialog = false" :loading="loading">
          Export Approved Bill Lines
        </v-btn>
      </download-excel>

      <div v-else-if="$route.name == 'billing'">
        <v-btn 
        :color="primaryNeutral" 
        flat 
        @click="fetchBillingTripsCsvArray" 
        :loading="loading"
      >Export Bills</v-btn>
      <download-excel 
        :fetch="() => billExportData"
        type="csv"
        :name="billExportName"
        style="display: none"
        ref="downloadCsv"
      ></download-excel>
      </div> 

      <download-excel :fetch="fetchTripsCsvArray" type="csv" name="trips.csv" v-else>
        <v-btn
          :color="primaryNeutral"
          flat
          @click="exportDialog = false"
          :loading="loading"
        >Export Trips</v-btn>
      </download-excel>
    </v-card-actions>
  </v-card>
</template>

<script>
import Store from '../../../store/computed/storeHelpers'
import DocketService from '@/services/requests/docketService'
import ApprovedBillLineService from '@/services/requests/approvedBillLineService'
import DownloadExcel from 'vue-json-excel'
import FormatDates from '@/services/mixins/formatDates'
import { addDays } from 'date-fns'
import BuildTripQuery from '@/services/mixins/buildTripQuery'
import BuildApprovedExportQuery from '@/modules/approvedBillLines/mixins/buildExportQuery'
export default {
  data() {
    return {
      loading: false,
      loadingXero: false,
      loadingTrips: false,
      billExportData: null,
      billExportName: 'trips.csv'
    }
  },
  components: {
    DownloadExcel
  },
  mixins: [FormatDates, BuildTripQuery, BuildApprovedExportQuery],
  props: {
    selected: Array,
    selectedAll: Boolean
  },
  methods: {
    close() {
      this.$emit('close')
    },
    getTrips(invoiceId, payload) {
      return DocketService[this.serviceType](invoiceId, payload)
        .then(async result => {
          return result.data.result
        })
        .catch(err => {
          this.loading = false
          this.snackError()
          console.log(err)
          return null
        })
    },
    fetchXeroCsvArray() {
      this.loading = true
      var array = []
      var obj = {}
      this.selected.forEach(async rcti => {
        rcti.rctiLines.forEach(rctiLine => {
          ;(obj = {
            ContactName: rcti.contractor.name,
            EmailAddress: '',
            POAddressLine1: '',
            POAddressLine2: '',
            POAddressLine3: '',
            POAddressLine4: '',
            POCity: '',
            PORegion: '',
            POPostalCode: '',
            POCountry: '',
            InvoiceNumber: !!rcti.externalRef ? rcti.externalRef : rcti.id,
            InvoiceDate: this.makeShortDate(rcti.date),
            DueDate: this.makeShortDate(addDays(Date.parse(rcti.date), 45)),
            InventoryItemCode: '',
            Description: rctiLine.description,
            Quantity: 1,
            UnitAmount: rctiLine.costTotal.toFixed(2),
            AccountCode: rctiLine.accountCode,
            TaxType: rctiLine.taxType,
            TrackingName1: '',
            TrackingOption1: '',
            TrackingName2: '',
            TrackingOption2: '',
            Currency: 'AUD'
          }),
            array.push(obj)
        })
      })
      this.loading = false
      this.close()
      return array
    },
    fetchTripsCsvArray() {
      if (this.$route.name == 'docket') return this.fetchPlainTripsCsvArray()
      else if (this.$route.name == 'billing')
        return this.fetchBillingTripsCsvArray()
      else return this.fetchInvoiceTripsCsvArray()
    },
    async fetchPlainTripsCsvArray() {
      this.loading = true
      var array = []
      var trips
      if (!this.selectedAll) {
        trips = this.selected
      } else {
        var query = this.buildQuery()
        query.pagination = this.$store.state.trips.pagination
        query.type = 'pdf'
        var result = await DocketService.getUnconfirmedTrips(query)
        trips = result.data.result
      }

      for (var trip of trips) {
        var obj = this.prepareTrip(trip)
        // obj.costTotal = Number(trip.costTotal).toFixed(2)
        // obj.costUnit = trip.costUnit
        // obj.costPrice = Number(trip.costPrice).toFixed(2)
        // obj.sellTotal = Number(trip.sellTotal).toFixed(2)
        // obj.sellUnit = trip.sellUnit
        // obj.sellPrice = Number(trip.sellPrice).toFixed(2)
        array.push(obj)
      }
      this.loading = false
      this.close()
      return array
    },
    async fetchBillingTripsCsvArray() {
      this.loading = true
      const approvedArray = []
      const trips = []
      for (const bill of this.selected) {
        const result = await this.getTrips(bill.id, {
          isApproved: bill.isApproved
        })
        if (result && result.length) {
          for (const item of result) {
            const trip = bill.isApproved ? item.trip : item
            const obj = this.prepareBillTrip(trip)
            obj.TripID = trip.id
            obj.Unit = trip.sellUnit
            obj.Qty = Number(bill.isApproved ? item.qty : trip.qty)
            obj.Amount = Number(
              bill.isApproved ? item.rate : trip.sellPrice
            ).toFixed(4)
            obj.Total = Number(
              bill.isApproved ? item.amount : trip.sellTotal
            ).toFixed(4)
            bill.isApproved ? approvedArray.push(obj) : trips.push(obj)
          }
        }
      }
      this.loading = false
      this.close()
      if (approvedArray.length) {
        this.billExportData = approvedArray
        this.billExportName = 'Bills.csv'
        this.$refs.downloadCsv.$el.click()
      }
      setTimeout(() => {
        if (trips.length) {
          this.billExportData = trips
          this.billExportName = 'trips.csv'
          this.$refs.downloadCsv.$el.click()
        }
        this.billExportData = null
      }, 3000)
    },
    async fetchInvoiceTripsCsvArray() {
      this.loading = true
      var dataToFetch = ''
      if (this.$route.name == 'billing') {
        dataToFetch = 'sell'
      } else {
        dataToFetch = 'cost'
      }

      var array = []
      for (var invoice of this.selected) {
        var trips = await this.getTrips(invoice.id)
        console.log(trips.length)
        trips.forEach(trip => {
          //var array = []
          var obj = this.prepareBillTrip(trip)
          obj[`${dataToFetch}Price`] = Number(
            trip[dataToFetch + 'Price']
          ).toFixed(2)
          obj[`${dataToFetch}Unit`] = trip[dataToFetch + 'Unit']
          obj[`${dataToFetch}Total`] = Number(
            trip[dataToFetch + 'Total']
          ).toFixed(2)
          array.push(obj)
        })
      }
      this.loading = false
      this.close()
      return array
    },
    prepareTrip(trip) {
      return {
        TripID: trip.id,
        Type: trip.docket.type,
        Date: trip.docket ? this.makeShortDate(trip.docket.date) : null,
        DateReceived: trip.docket
          ? this.makeShortDate(trip.docket.dateReceived)
          : null,
        Project: trip.docket ? trip.docket.site.project.name : null,
        Site: trip.docket ? trip.docket.site.name : null,
        Subcontractor: trip.docket ? trip.docket.vehicle.contractor.name : null,
        Reference: trip.docket ? trip.docket.externalRef : null,
        createdAt: this.makeShortDate(trip.docket.createdAt),
        Driver: trip.docket ? trip.docket.driver.name : null,
        Vehicle: trip.docket ? trip.docket.vehicle.name : null,
        VehicleType: trip.docket ? trip.docket.vehicle.vehicleType.name : null,
        Spoil: trip.spoil ? trip.spoil.name : null,
        WeighbridgeDocketNumber: trip.wbDocketNumber,
        'Tip / WB Weight': trip.siteWeight,
        'Site / LR Weight': trip.tipWeight,
        'Truck / Scale Weight': trip.scaleWeight,
        Tip: trip.tip ? trip.tip.name : null,
        TSE: trip.tip ? trip.tip.number : null,
        Spoil: trip.spoil ? trip.spoil.name : null,
        Start: this.getUTCTime(trip.start),
        Breaks: trip.breaks,
        End: this.getUTCTime(trip.end),
        Travel: trip.travel,
        BillableHours: trip.hours,
        Notes: trip.notes,
        GPSNotes: trip.GPSNotes,
        TippingDocketNotes: trip.tippingDocketNotes,
        Billed: trip.approvedBillingAmount,
        Waived: trip.waivedAmount,
        Outstanding: trip.outstandingBillingAmount,
        RateID: trip.rateId,
        RateType: trip.rateType,
        AdminFeeRequired: trip.rate ? trip.rate.adminFeeRequired : null,
        AdminFeePercentage: trip.docket
          ? trip.docket.vehicle.contractor.adminFeePercentage
          : null,
        BillID: trip.billId,
        RctiID: trip.rctiId,
        BillingPeriod: trip.docket ? trip.docket.billingPeriod : null,
        Type: trip.docket ? trip.docket.type : null,
        TippingDocketId: trip.tippingDocketLineId,
        Qty: trip.qty,
        CostPrice: Number(trip.costPrice).toFixed(2),
        CostUnit: trip.costUnit,
        CostTotal: Number(trip.costTotal).toFixed(2),
        SellPrice: Number(trip.sellPrice).toFixed(2),
        SellUnit: trip.sellUnit,
        SellTotal: Number(trip.sellTotal).toFixed(2),
        EnteredBy: trip.docket ? trip.docket.createdBy.name : null,
        UpdatedBy: trip.updatedBy ? trip.updatedBy.name : null,
        CreatedAt: this.makeShortDateAndTime(trip.createdAt),
        UpdatedAt: this.makeShortDateAndTime(trip.updatedAt),
        DocketUpdatedAt: trip.docket
          ? this.makeShortDateAndTime(trip.docket.updatedAt)
          : null
      }
    },
    prepareBillTrip(trip) {
      return {
        'Billing Period': trip.docket.billingPeriod,
        Date: trip.docket ? this.makeShortDate(trip.docket.date) : null,
        Project: trip.docket ? trip.docket.site.project.name : null,
        Site: trip.docket ? trip.docket.site.name : null,
        Subcontractor: trip.docket ? trip.docket.vehicle.contractor.name : null,
        Reference: trip.docket ? trip.docket.externalRef : null,
        createdAt: this.makeShortDate(trip.docket.createdAt),
        Driver: trip.docket ? trip.docket.driver.name : null,
        Vehicle: trip.docket ? trip.docket.vehicle.name : null,
        VehicleType: trip.docket ? trip.docket.vehicle.vehicleType.name : null,
        Spoil: trip.spoil ? trip.spoil.name : null,
        WeighbridgeDocketNumber: trip.wbDocketNumber,
        Weight: trip.siteWeight,
        Tip: trip.trip ? trip.tip.name : null,
        TSE: trip.trip ? trip.tip.number : null,
        Start: this.getUTCTime(trip.start),
        Breaks: trip.breaks,
        End: this.getUTCTime(trip.end),
        Travel: trip.travel,
        BillableHours: trip.hours,
        Billed: trip.approvedBillingAmount,
        Waived: trip.waivedAmount,
        Outstanding: trip.outstandingBillingAmount,
        Notes: trip.notes
      }
    },
    async fetchApprovedCsvArray() {
      this.loading = true
      const array = []
      let approved = []
      if (!this.selectedAll) {
        approved = this.selected
      } else {
        const payload = this.buildExportQuery()
        const result = await ApprovedBillLineService.getApprovedBillLines(
          payload
        )
        approved = result.data.result
      }
      for (const line of approved) {
        const obj = this.prepareApproved(line)
        array.push(obj)
      }
      this.loading = false
      this.close()
      return array
    },
    prepareApproved(line) {
      return {
        ID: line.trip.id,
        'Billing Period': line.trip.docket.billingPeriod,
        Date: this.makeShortDate(line.trip.docket.date),
        'Customer Claim Ref': line.customerClaimRef,
        Project: line.trip.docket.site.project.name,
        Site: line.trip.docket.site.name,
        'Trip ID': line.tripId,
        Spoil: line.trip.spoil.name,
        Tip: line.trip.tip.name,
        'Bill Quantity': line.qty,
        'Bill Rate': line.rate,
        'Bill Amount': line.amount,
        Notes: line.notes,
        'Bill Line ID': line.billLineId,
        CreatedBy: line.createdBy.name,
        CreatedAt: this.makeShortDate(line.createdAt)
      }
    },
    getBillExportData() {}
  },
  computed: {
    serviceType() {
      let serviceType = 'getTripsByRcti'
      if (this.$route.name == 'billing') serviceType = 'getTripsByBill'
      return serviceType
    },
    billingPeriod: Store.getSet({ store: 'shared', prop: 'billingPeriod' })
  }
}
</script>

<style>
</style>
